import React from 'react';
import styled from 'styled-components';
import { motion } from 'motion/react';
import Contributor from './Contributor';

function Contributors({
  contributors,
  comments,
  variants,
  totalQuestions,
  onlineUsers,
  sessionId
}) {
  return null;
  // <ContributorsContainer
  //   key="contributors"
  //   variants={variants}
  //   initial="hidden"
  //   animate="visible"
  //   exit="hidden">
  //   <h3>Contributors</h3>
  //   {contributors.map((contributor) => (
  //     <Contributor
  //       key={contributor.id}
  //       contributor={contributor}
  //       comments={comments}
  //       totalQuestions={totalQuestions}
  //       onlineUsers={onlineUsers}
  //       sessionId={sessionId}
  //     />
  //   ))}
  // </ContributorsContainer>
}

const ContributorsContainer = styled(motion.div)`
  border-top: 1px solid var(--light-grey);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 0;
  width: 100%;
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
  }
`;

export default Contributors;
